/* eslint-disable indent */
/**
 * File: forms.js.
 *
 * Handles functions on WPForms
 */

const $ = require('jquery');

export default {
  form: document.querySelector('.js-wp-form'),
  init() {
    if (this.form) {
      this.render();
    }
  },
  animateLabel() {
    const formContainer = this.form.querySelectorAll('.js-wp-form-input');

    [ ...formContainer ].forEach((form) => {
      const label = form.querySelector('label');
      const field = form.querySelector('input') || form.querySelector('select');

      if ($(field).is('select')) {
        label.classList.add('field-focus');
      } else {
        field.addEventListener('focusin', () => {
          label.classList.add('field-focus');
        });

        field.addEventListener('focusout', (e) => {
          if (e.target && ! e.target.value) {
            label.classList.remove('field-focus');
          }
        });
      }
    });
  },
  customDropdown() {
    const selectField = document.querySelectorAll('.js-wp-form-select');

    [ ...selectField ].map((field) => {
      const select = field.querySelector('select');
      const selectClass = select.classList[ 0 ];

      const selectArrow = document.createElement('span');
      selectArrow.setAttribute('class', 'select-arrow');

      const dropdownContainer = document.createElement('div');
      dropdownContainer.setAttribute('class', 'select-dropdown');

      // cereate ul element that lists dropdown option from original select field
      const ul = document.createElement('ul');
      ul.setAttribute('class', 'select-dropdown__options');

      [ ...select.options ].forEach((option) => {
        const li = document.createElement('li');
        li.innerHTML = option.innerHTML;
        ul.appendChild(li);
      });

      switch (selectClass) {
        case 'wpforms-field-small':
          selectArrow.classList.add('wpforms-field-small');
          dropdownContainer.classList.add(selectClass);
          break;
        case 'wpforms-field-medium':
          selectArrow.classList.add('wpforms-field-medium');
          dropdownContainer.classList.add(selectClass);
          break;
        case 'wpforms-field-large':
          selectArrow.classList.add('wpforms-field-large');
          dropdownContainer.classList.add(selectClass);
          break;
      }

      // append input and list to select container
      dropdownContainer.appendChild(ul);
      field.appendChild(dropdownContainer);
      field.appendChild(selectArrow);

      this.selectDropdown(select, dropdownContainer);
    });
  },
  selectDropdown(select, dropdown) {
    const options = dropdown.querySelectorAll('ul li');

    $(document).on('click', (e) => {
      if ($(e.target).is(select)) {
        $(dropdown).toggleClass('dropdown-visible');
      } else if (! $(e.target).is(dropdown) && $(dropdown).hasClass('dropdown-visible')) {
        $(dropdown).removeClass('dropdown-visible');
      }
    });

    options.forEach((option, i) => {
      $(option).on('click', () => {
        $(option).addClass('option-selected');
        if (select.options[ i ].value === option.innerText) {
          select.options[ i ].selected = 'selected';
        }
        $(dropdown).removeClass('dropdown-visible');
      });
      $(document).on('click', (e) => {
        if ($(e.target).is(option) === false) {
          $(option).removeClass('option-selected');
        }
      });
    });
  },
  render() {
    this.customDropdown();
    this.animateLabel();
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
